<template>
    <van-popup v-model:show="show" @close="handleReceive" style="background: rgba(0,0,0,0);" closeable
        close-icon="clear">
        <div class="popup-box">
            <div class="content">
                <div class="title">{{ t('tyjPopup.a1') }}</div>
                <p class="msg">{{ t('tyjPopup.a5') }}</p>
                <p class="msg2">{{ t('tyjPopup.a6') }}{{ props.data.content?.price }} {{ t('tyjPopup.a7') }}</p>
                <div class="time-con">
                    {{ t('tyjPopup.a8') }}
                    <div class="time-box">
                        <div class="time-item">{{ time.hours }}</div>
                        <div class="time-dot">:</div>
                        <div class="time-item">{{ time.minutes }}</div>
                        <div class="time-dot">:</div>
                        <div class="time-item">{{ time.seconds }}</div>
                    </div>
                </div>
                <div class="con">
                    <span>{{ props.data.content?.price }}</span>
                    <div class="rg">
                        ARS
                    </div>
                </div>
                <van-button type="default" class="btn" @click="handleReceive(true)">
                    {{ t('tyjPopup.a9') }}
                </van-button>
            </div>
        </div>
    </van-popup>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
import { useCountdown } from "@/utils/useCountdown2";
import { getCountDown } from "@/utils/globalMethods"
import { readNoticeApi } from "@/api"
import { showToast, showSuccessToast } from 'vant';
import { useMainStore } from "@/store"
import { useI18n } from "vue-i18n"
import { useRouter } from 'vue-router';
const router = useRouter()
const { t } = useI18n()
const mainStore = useMainStore()

/**
 * Props
 */
const props = defineProps({
    modelValue: { type: Boolean, default: false },   // v-model:show
    data: {
        type: Object,
        default: () => ({})
    }
})

const { end } = toRefs(props.data)

/**
 * Emits
 */
const emit = defineEmits(["update:modelValue"])

const show = ref(props.modelValue)

// 同步 v-model:show
watch(
    () => props.modelValue,
    (val) => {
        show.value = val
    }
)

watch(show, (val) => {
    emit("update:modelValue", val)
})

const time = ref<any>('')
const timer = null
watch(
    () => props.data.content?.end,
    () => {
        if (props.data.content?.end) {
            if (timer) {
                clearInterval(timer)
            }
            setInterval(() => {
                time.value = getCountDown(props.data.content?.end);
            }, 1000)
        }
    },
    { immediate: true }
)

/**
 * 点击按钮
 */
const read = async (idVal: string,e:any) => {
    try {
        const res = await readNoticeApi({
            id: idVal
        });
        if(e){
            router.push('/AiTrialBonus?id=' + props.data.content.id)
        }
    } catch (error) {
        console.error(error);
    }
};

function handleReceive(e) {
    const ids = props.data.id
    read(ids,e)
    mainStore.setTrialBalance(true)
    emit("guanbi", false)
}

onUnmounted(() => {
    if (timer) {
        clearInterval(timer)
    }
});
</script>

<style scoped lang="scss">
.popup-box {
    width: 90vw;
    max-width: 350px;
    border-radius: 20px;
    background: linear-gradient(180deg, #FFF 35%, #CDE8FF 100%);

    .content {
        width: 100%;
        height: 100%;
        background-image: url("@/assets/images/tyjTitle.png"), url("@/assets/images/tyjbg.png");
        background-repeat: no-repeat;
        background-size: 280px, 252px;
        background-position: top, center 80%;
        padding: 12px 10px 20px;

        .title {
            color: #010611;
            text-align: center;
            font-family: "Microsoft YaHei UI";
            font-size: 22px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
        }

        .msg,
        .msg2 {
            color: #001543;
            text-align: center;
            font-family: "Microsoft YaHei UI";
            font-size: 18px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
            margin-top: 25px;
        }

        .msg2 {
            margin-top: 5px;
        }

        .time-con {
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 8px;

            .time-box {
                display: flex;
                align-items: center;
                gap: 6px; // 每个方块之间的距离
                margin-left: 10px;

                .time-item {
                    min-width: 22px;
                    height: 20px;
                    background: #2D74FF; // 蓝色背景
                    border-radius: 6px; // 圆角
                    color: #FFF;
                    font-family: "Microsoft YaHei UI";
                    font-size: 16px;
                    font-style: normal;
                    font-weight: 700;
                    line-height: normal;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                .time-dot {
                    font-size: 16px;
                    font-weight: bold;
                    color: #2D74FF;
                }
            }

        }

        .con {
            border-radius: 8px;
            border: 1px solid #CEE9FF;
            background: linear-gradient(180deg, rgba(255, 255, 255, 0.40) 0%, rgba(228, 246, 255, 0.20) 100%);
            backdrop-filter: blur(7.5px);
            margin-top: 100px;
            margin-bottom: 15px;
            padding: 10px 0;
            display: flex;
            align-items: center;
            justify-content: center;

            span {
                color: #2969FF;
                font-family: Inter;
                font-size: 64px;
                font-style: normal;
                font-weight: 900;
                line-height: 69.723px;
            }

            .rg {
                display: flex;
                flex-direction: column;
                gap: 7px;
                color: #2FA1FF;
                font-family: "Microsoft YaHei UI";
                font-size: 19.476px;
                font-style: normal;
                font-weight: 700;
                line-height: 19.368px;
                transform: rotate(90deg);
            }
        }

        .btn {
            margin-top: 16px;
            width: 100%;
            border-radius: 10px;
            background: #2969FF;
            border-color: #2969FF;
            color: #FFF;
            text-align: center;
            font-family: "Microsoft YaHei UI";
            font-size: 16px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
        }
    }
}
</style>